import { NewProductDetails } from 'application-types';
import { isMarkupValueValid } from '../../helpers/isMarkupValueValid';
import { isTaxValueValid } from '../../helpers/isTaxValueValid';
import { isNumberTwoDecimalPlaces } from '../../helpers/isNumberTwoDecimalPlaces';

export interface ProductFormValidationOptions {
  inclusivePricing: boolean;
  requireCategory?: boolean;
  validateCreditAmount?: boolean;
}

function isPriceValid(price: string | undefined): boolean {
  if (!price || Number(price) < 0) return false;

  return isNumberTwoDecimalPlaces(parseFloat(price));
}

function isCreditAmountValid(creditAmount: string | undefined): boolean {
  if (creditAmount === undefined) return true;

  if (creditAmount === '') return false;

  if (parseFloat(creditAmount) < 0) return false;

  return isNumberTwoDecimalPlaces(parseFloat(creditAmount));
}

export function isProductFormValid(
  details: NewProductDetails,
  options: ProductFormValidationOptions
): boolean {
  const { name, rate, markup, tax, netPrice, productCategoryId, creditAmount } = details;
  const { inclusivePricing, requireCategory = true, validateCreditAmount = false } = options;

  if (!name) return false;

  if (requireCategory && !productCategoryId) return false;

  const priceToValidate = inclusivePricing ? netPrice : rate;

  if (!isPriceValid(priceToValidate)) return false;

  if (!isMarkupValueValid(markup)) return false;

  if (!isTaxValueValid(tax)) return false;

  if (validateCreditAmount && !isCreditAmountValid(creditAmount)) return false;

  return true;
}

